"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UniformObject_1 = require("./UniformObject");
/**
 * @author Kentaro Kawakatsu
 */
var ShaderObject = /** @class */ (function () {
    function ShaderObject($context) {
        this.context = $context;
        this.uniformList = [];
        this.attributeList = [];
        this.init();
    }
    ShaderObject.prototype.init = function () {
    };
    ShaderObject.prototype.createProgram = function () {
        this.vShader = this.creatShader(this.vShaderSource, this.context.VERTEX_SHADER);
        this.fShader = this.creatShader(this.fShaderSource, this.context.FRAGMENT_SHADER);
        this.program = this.context.createProgram();
        this.context.attachShader(this.program, this.vShader);
        this.context.attachShader(this.program, this.fShader);
        this.context.linkProgram(this.program);
        var i;
        var length;
        length = this.attributeList.length;
        for (i = 0; i < length; i++) {
            var attribute = this.attributeList[i];
            attribute.location = this.context.getAttribLocation(this.program, attribute.name);
        }
        length = this.uniformList.length;
        for (i = 0; i < length; i++) {
            var uniform = this.uniformList[i];
            uniform.location = this.context.getUniformLocation(this.program, uniform.name);
        }
    };
    ShaderObject.prototype.bindShader = function () {
        this.bindProgram();
        this.bindUniform();
    };
    ShaderObject.prototype.bindProgram = function () {
        if (this.context.getProgramParameter(this.program, this.context.LINK_STATUS)) {
            this.context.useProgram(this.program);
        }
        else {
            console.log(this.context.getProgramInfoLog(this.program));
        }
    };
    ShaderObject.prototype.bindUniform = function () {
        var length = this.uniformList.length;
        for (var i = 0; i < length; i++) {
            var uniform = this.uniformList[i];
            switch (uniform.type) {
                case UniformObject_1.UniformObject.TYPE_MATRIX:
                    this.context.uniformMatrix4fv(uniform.location, false, uniform.matrix);
                    break;
                case UniformObject_1.UniformObject.TYPE_VALUE:
                    this.context.uniform1f(uniform.location, uniform.value);
                    break;
                case UniformObject_1.UniformObject.TYPE_VECTOR3:
                    this.context.uniform3fv(uniform.location, uniform.vector3);
                    break;
                case UniformObject_1.UniformObject.TYPE_VECTOR4:
                    this.context.uniform4fv(uniform.location, uniform.vector4);
                    break;
                case UniformObject_1.UniformObject.TYPE_TEXTURE:
                    this.context.uniform1i(uniform.location, uniform.value);
                    this.context.activeTexture(this.context["TEXTURE" + uniform.value]);
                    this.context.bindTexture(this.context.TEXTURE_2D, uniform.texture);
                    break;
                default:
                    break;
            }
        }
    };
    ShaderObject.prototype.creatShader = function (source, type) {
        var shader = this.context.createShader(type);
        this.context.shaderSource(shader, source);
        this.context.compileShader(shader);
        if (this.context.getShaderParameter(shader, this.context.COMPILE_STATUS)) {
            return shader;
        }
        else {
            console.log(type === this.context.VERTEX_SHADER, this.context.getShaderInfoLog(shader));
            return null;
        }
    };
    ShaderObject.prototype.getUniform = function (uniformName) {
        var length = this.uniformList.length;
        for (var i = 0; i < length; i++) {
            var uniform = this.uniformList[i];
            if (uniform.name === uniformName) {
                return uniform;
            }
        }
        return null;
    };
    return ShaderObject;
}());
exports.ShaderObject = ShaderObject;



//////////////////
// WEBPACK FOOTER
// ./src/ts/myLib/webgl/engine/ShaderObject.ts
// module id = 22
// module chunks = 0